import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import { getValidationRulesFromMap } from "@Client/@Composables/application-standalone/validations/getValidationRulesFromMap";
import { computed, ref } from "@vue/composition-api";
import { useVuelidate } from "@vuelidate/core";
import { between } from "@vuelidate/validators";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { assetsPageBindingsAndVisibilities } from "@Client/@Composables/application-standalone/pages/assets/assetsPageBindingsAndVisibilities";
import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { camelCase, capitalize, mapKeys } from "lodash";
export const assetValidator = (applicantIndex, assetIndex, {
  lazy = false
} = {}) => {
  const {
    bindings
  } = assetsPageBindingsAndVisibilities(applicantIndex, assetIndex, ref("0"));
  const {
    assetType,
    assetDescription,
    assetAmount
  } = bindings;
  const applicantPrefix = computed(() => {
    return applicantIndex.value ? "applicant" : "";
  });
  const {
    GET_SCHEMA_RULES_BY_PATH,
    HAS_CONSOLIDATED_REQUEST
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_SCHEMA_RULES_BY_PATH, ApplicationStandaloneGetters.HAS_CONSOLIDATED_REQUEST]);
  const {
    isApplicantVisibleFromFillOut,
    getApplicantIdByIndex
  } = useApplicantHelpers();
  const areRulesVisibleFromFillOut = () => !HAS_CONSOLIDATED_REQUEST.value || isApplicantVisibleFromFillOut(getApplicantIdByIndex(applicantIndex.value));
  const rules = computed(() => {
    return getValidationRulesFromMap(areRulesVisibleFromFillOut, GET_SCHEMA_RULES_BY_PATH, assetPageRules, applicantPrefix.value);
  });
  const v$ = useVuelidate(rules, {
    assetType,
    assetDescription,
    assetAmount
  }, {
    $scope: true,
    $lazy: lazy
  });
  return {
    v$
  };
};
const assetPageRules = {
  assetType: {},
  assetDescription: {},
  assetAmount: {
    between: between(0, 1000000000000)
  }
};
export const assetsValidator = ({
  lazy = false
} = {}) => {
  const {
    allAssets: assets
  } = useApplicantHelpers();
  const {
    GET_SCHEMA_RULES_BY_PATH
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_SCHEMA_RULES_BY_PATH]);
  const {
    isApplicantVisibleFromFillOut
  } = useApplicantHelpers();
  const allAssets = computed(() => {
    var _context;
    return _flatMapInstanceProperty(_context = assets.value).call(_context, item => isApplicantVisibleFromFillOut(item.applicantId) ? mapKeys(item, (_value, key) => camelCase("asset" + capitalize(key))) : []);
  });
  const getRules = () => {
    var _context2;
    const mainApplicantRules = getValidationRulesFromMap(() => true, GET_SCHEMA_RULES_BY_PATH, assetPageRules);
    const coApplicantRules = getValidationRulesFromMap(() => true, GET_SCHEMA_RULES_BY_PATH, assetPageRules, "applicant");
    return _reduceInstanceProperty(_context2 = allAssets.value).call(_context2, (acc, _asset, index) => {
      acc[index] = _asset.applicantIndex ? coApplicantRules : mainApplicantRules;
      return acc;
    }, {});
  };
  const rules = computed(getRules);
  const v$ = useVuelidate(rules, allAssets, {
    $scope: "assets",
    $lazy: lazy
  });
  return {
    v$
  };
};